// extracted by mini-css-extract-plugin
module.exports = {"params":"GovernanceParams_params__2SRfN"};